import { useQuery } from '@tanstack/react-query'
import { dashboardService } from '@/services/dashboard'

// Get dashboard overview
export const useDashboardOverview = (organizationId?: string) => {
  return useQuery({
    queryKey: ['dashboard', 'overview', organizationId],
    queryFn: () => dashboardService.getOverview(organizationId),
    refetchInterval: 60000, // Refetch every minute
  })
}

// Get dashboard subscriptions
export const useDashboardSubscriptions = (organizationId?: string) => {
  return useQuery({
    queryKey: ['dashboard', 'subscriptions', organizationId],
    queryFn: () => dashboardService.getSubscriptions(organizationId),
  })
}

// Get dashboard usage
export const useDashboardUsage = (organizationId?: string) => {
  return useQuery({
    queryKey: ['dashboard', 'usage', organizationId],
    queryFn: () => dashboardService.getUsage(organizationId),
    refetchInterval: 30000, // Refetch every 30 seconds
  })
}

